import React, { useState, useEffect } from 'react'
import { formatMoney } from '../../helpers/utils'
import dayjs from '../../utils/dayjsConfig'
import { ASSIGN_STATUS_TYPES_DIC } from '../constants/constants'

export default function DocumentsInAssignDeliveryList({
  document,
  documentIndex,
  selectedDocuments,
  addToSelectedDocuments,
  deleteFromSelectedDocuments,
  openAssignModal
}) {
  const showModel = (event, model) => {
    event.preventDefault()
    const id = model.delivery_reference
    const status = model.status

    window.open(`/entregas/${encodeURIComponent(id)}?status=${status}`, '_blank')
  }
  const getFormattedDate = (createdDate) => {
    return dayjs(createdDate).format('DD/MM/YYYY HH:mm A')
  }

  const isThisDocumentChecked = selectedDocuments.some((d) => d.uid === document.uid)

  const handleCheckedDocument = () => {
    if (isThisDocumentChecked) {
      deleteFromSelectedDocuments(document.uid, document.status)
    } else {
      addToSelectedDocuments(document.uid, document.status)
    }
  }

  const handleAssignButtonClick = () => {
    if (!isThisDocumentChecked) {
      addToSelectedDocuments(document.uid, document.status)
    }
    openAssignModal()
  }

  return (
    <tr className="cursor-pointer" key={documentIndex}>
      <td className="td-text-limited td-text-limited-space" id={document.uid}>
        <input
          id={document.uid}
          type="checkbox"
          checked={isThisDocumentChecked}
          onChange={() => handleCheckedDocument()}
          disabled={document.status === ASSIGN_STATUS_TYPES_DIC.PROCESSING}
        />
      </td>
      <td className="td-text-limited " id={document.uid}>
        {getFormattedDate(document.document_created_date)}
      </td>
      <td className="td-text-limited" id={document.uid}>
        {document.client_db_ref}
      </td>
      <td className="td-text-limited" id={document.uid}>
        {document.client_name}
      </td>
      <td className="td-text-limited" id={document.uid}>
        {document.client_is_cash === true
          ? 'CONTADO'
          : document.client_is_cash === false
            ? 'CRÉDITO'
            : '-'}
      </td>
      <td className="td-text-limited" id={document.uid}>
        {document.address_delivery || '-'}
      </td>
      <td
        className="td-text-limited ubiqua-link"
        id={document.uid}
        onClick={(event) =>
          document.status != ASSIGN_STATUS_TYPES_DIC.PROCESSING ? showModel(event, document) : ''
        }
      >
        {document.delivery_reference}
      </td>
      <td className="td-text-limited" id={document.uid}>
        {document.delivery_type_text || document.delivery_type}
      </td>
      <td className="td-text-limited" id={document.uid}>
        {formatMoney(Number(document.total))}
      </td>
      <td className="td-text-limited" id={document.uid}>
        {document.salesman_db_ref ? `${document.salesman_db_ref} - ${document.salesman_name}` : '-'}
      </td>
      <td className="td-text-limited" id={document.uid}>
        {document.visit_date ? dayjs(document.visit_date).format('DD/MM/YYYY') : '-'}
      </td>
      <td className="td-text-limited" id={document.uid}>
        <div>
          {document.status === ASSIGN_STATUS_TYPES_DIC.TO_BE_ASSIGNED && (
            <div className="assign-delivery-to-be-assigned">POR ASIGNAR</div>
          )}
          {document.status === ASSIGN_STATUS_TYPES_DIC.PROCESSING && (
            <div className="assign-delivery-processing">EN PROCESO...</div>
          )}
          {document.status === ASSIGN_STATUS_TYPES_DIC.OPEN && (
            <div className="assign-delivery-open">ASIGNADO</div>
          )}
        </div>
      </td>
      <td className="td-text-limited" id={document.uid}>
        {document.status === ASSIGN_STATUS_TYPES_DIC.OPEN && (
          <button
            type="button"
            onClick={() => handleAssignButtonClick()}
            className="reassign-delivery-button"
          >
            RE-ASIGNAR
          </button>
        )}
        {document.status === ASSIGN_STATUS_TYPES_DIC.TO_BE_ASSIGNED && (
          <button
            type="button"
            onClick={() => handleAssignButtonClick()}
            className="assign-delivery-button"
          >
            ASIGNAR
          </button>
        )}
        {document.status === ASSIGN_STATUS_TYPES_DIC.PROCESSING && (
          <button type="button" disabled={true} className="disabled-delivery-button">
            ASIGNAR
          </button>
        )}
      </td>
    </tr>
  )
}
